import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, mergeProps as _mergeProps, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "bar" };
const _hoisted_2 = { class: "bar__inner" };
const _hoisted_3 = { class: "bar__actions" };
import { computed, onBeforeUnmount, ref, watch } from "vue";
import { MOD_KEY } from "@/utils/platformKeys";
import { REGENERATE_ANSWERS_TOOLTIP } from "@/models/paStatus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaActionBar',
    props: {
        actions: {},
        saveState: { default: "saved" },
        viewerMode: { type: Boolean, default: false }
    },
    emits: ["back", "send-plan", "send-prescriber", "regenerate", "save-draft", "archive", "unarchive", "shortcuts"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const justSaved = ref(false);
        let savedTimer;
        watch(() => props.saveState, (state, previous) => {
            if (state === "saved" && (previous === "saving" || previous === "dirty")) {
                justSaved.value = true;
                clearTimeout(savedTimer);
                savedTimer = setTimeout(() => (justSaved.value = false), 2500);
            }
        });
        const saveLabel = computed(() => {
            if (props.saveState === "saved")
                return justSaved.value ? "Saved" : "";
            return { dirty: "Unsaved changes", saving: "Saving", error: "Not saved", viewing: "View only" }[props.saveState];
        });
        onBeforeUnmount(() => clearTimeout(savedTimer));
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        class: "bar__back",
                        "aria-label": "Back to the list",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('back')))
                    }, [
                        _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode("mdi-arrow-left", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "bar__back-label" }, "Back", -1))
                    ]),
                    (saveLabel.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["bar__save", `bar__save--${__props.saveState}`])
                        }, [
                            (__props.saveState === 'saving')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    size: "14",
                                    class: "bar__spin"
                                }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                            _createTextVNode("mdi-loading", -1)
                                        ]))]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(saveLabel.value), 1)
                        ], 2))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_menu, {
                            location: "top end",
                            offset: 8
                        }, {
                            activator: _withCtx(({ props: menu }) => [
                                _createElementVNode("button", _mergeProps({ class: "bar__icon" }, menu, { "aria-label": "More actions" }), [
                                    _createVNode(_component_v_icon, { size: "18" }, {
                                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                _createTextVNode("mdi-dots-horizontal", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ], 16)
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_v_list, {
                                    density: "compact",
                                    class: "bar__menu"
                                }, {
                                    default: _withCtx(() => [
                                        (!__props.viewerMode)
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 0,
                                                "prepend-icon": "mdi-content-save-outline",
                                                title: "Save draft",
                                                disabled: !__props.actions.saveable || __props.actions.saving,
                                                onClick: _cache[1] || (_cache[1] = ($event) => (emit('save-draft')))
                                            }, null, 8, ["disabled"]))
                                            : _createCommentVNode("", true),
                                        (!__props.viewerMode && __props.actions.archivable && !__props.actions.archived)
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 1,
                                                "prepend-icon": "mdi-archive-outline",
                                                title: "Archive",
                                                subtitle: __props.actions.archiveDisabledReason || undefined,
                                                disabled: Boolean(__props.actions.archiveDisabledReason),
                                                onClick: _cache[2] || (_cache[2] = ($event) => (emit('archive')))
                                            }, null, 8, ["subtitle", "disabled"]))
                                            : _createCommentVNode("", true),
                                        (!__props.viewerMode && __props.actions.archivable && __props.actions.archived)
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 2,
                                                "prepend-icon": "mdi-archive-arrow-up-outline",
                                                title: "Unarchive",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (emit('unarchive')))
                                            }))
                                            : _createCommentVNode("", true),
                                        _createVNode(_component_v_list_item, {
                                            "prepend-icon": "mdi-keyboard-outline",
                                            title: "Keyboard shortcuts",
                                            onClick: _cache[4] || (_cache[4] = ($event) => (emit('shortcuts')))
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        (!__props.viewerMode)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (__props.actions.regenerateVisible)
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 0,
                                        text: _unref(REGENERATE_ANSWERS_TOOLTIP),
                                        location: "top"
                                    }, {
                                        activator: _withCtx(({ props: tip }) => [
                                            _createVNode(_component_v_btn, _mergeProps(tip, {
                                                class: "bar__btn",
                                                variant: "outlined",
                                                color: "primary",
                                                rounded: "lg",
                                                loading: __props.actions.regenerating,
                                                disabled: __props.actions.saving,
                                                onClick: _cache[5] || (_cache[5] = ($event) => (emit('regenerate')))
                                            }), {
                                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                        _createTextVNode(" Regenerate ", -1)
                                                    ]))]),
                                                _: 1
                                            }, 16, ["loading", "disabled"])
                                        ]),
                                        _: 1
                                    }, 8, ["text"]))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_tooltip, {
                                    text: __props.actions.prescriberDisabledReason || '',
                                    disabled: !__props.actions.prescriberDisabledReason,
                                    location: "top"
                                }, {
                                    activator: _withCtx(({ props: tip }) => [
                                        _createElementVNode("span", _normalizeProps(_guardReactiveProps(tip)), [
                                            _createVNode(_component_v_btn, {
                                                class: "bar__btn",
                                                variant: "outlined",
                                                color: "primary",
                                                rounded: "lg",
                                                loading: __props.actions.prescriberSending,
                                                disabled: __props.actions.prescriberDisabled || __props.actions.saving,
                                                onClick: _cache[6] || (_cache[6] = ($event) => (emit('send-prescriber')))
                                            }, {
                                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                        _createTextVNode(" Send to prescriber ", -1)
                                                    ]))]),
                                                _: 1
                                            }, 8, ["loading", "disabled"])
                                        ], 16)
                                    ]),
                                    _: 1
                                }, 8, ["text", "disabled"]),
                                _createVNode(_component_v_tooltip, {
                                    text: __props.actions.submitDisabledReason || `Send to plan  ${_unref(MOD_KEY)} Enter`,
                                    location: "top"
                                }, {
                                    activator: _withCtx(({ props: tip }) => [
                                        _createElementVNode("span", _normalizeProps(_guardReactiveProps(tip)), [
                                            _createVNode(_component_v_btn, {
                                                class: "bar__btn",
                                                color: "primary",
                                                variant: "flat",
                                                rounded: "lg",
                                                loading: __props.actions.saving,
                                                disabled: __props.actions.submitDisabled,
                                                onClick: _cache[7] || (_cache[7] = ($event) => (emit('send-plan')))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(__props.actions.submitLabel || "Send to Plan"), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["loading", "disabled"])
                                        ], 16)
                                    ]),
                                    _: 1
                                }, 8, ["text"])
                            ], 64))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
